import { reactive, computed } from 'vue'
import { showToast } from '@/shared/toast/toast'

/** Уведомление по встрече: ответ гостя или перенос времени. */
export interface CalendarAlert {
  action: string
  eventId: number
  title: string
  text: string
}

const state = reactive({
  items: [] as CalendarAlert[],
})

/**
 * Уведомления по календарю для организатора и участников: гость ответил на
 * приглашение, встречу перенесли. Копятся значком на пункте «Календарь» —
 * раньше об ответе гостя нельзя было узнать, не открыв карточку встречи.
 */
export function useCalendarAlerts() {
  const count = computed(() => state.items.length)

  function onSocket(payload: {
    action?: string
    event_id?: number
    title?: string
    guest_name?: string
    confirmed?: boolean
    starts_at?: string
  }): void {
    const title = payload?.title || 'Встреча'
    let text: string
    if (payload?.action === 'guest_rsvp') {
      const who = payload.guest_name || 'Гость'
      text = payload.confirmed
        ? `${who} подтвердил участие: «${title}»`
        : `${who} отклонил приглашение: «${title}»`
    } else if (payload?.action === 'event_time_changed') {
      text = `Изменилось время встречи «${title}»`
    } else {
      return
    }

    state.items.push({
      action: String(payload.action),
      eventId: Number(payload.event_id || 0),
      title,
      text,
    })
    showToast(text)
  }

  function clear(): void {
    state.items = []
  }

  return { state, count, onSocket, clear }
}
